// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"881ae238","453":"8c615ee3","455":"d959a37e"}[chunkId] + ".chunk.js";
};